import { useState } from 'react';
import RichTextEditor from '@/component/formManagement/fieldUI/RichTextEditor';
import { cloneDeep } from 'lodash';


export default function ReplyEmailBody({
    originTicket,
    fieldData,
    isCustomerMail = false,
    detailTicket,
    onclickReplyTicket,
    replyToEmailTicket,
    setIsEdited,
    register,
    setValue,
    triggerEnableBtnSaveTicket
}) {
    const [onChangeEdit, setOnChangeEdit] = useState(false);
    const [listFieldEdited, setListFieldEdited] = useState([]);
    const [errorlist, setErrorlist] = useState('');

    // Create a deep copy of fieldData to avoid modifying read-only object
    const fieldDataCopy = fieldData ? cloneDeep(fieldData) : null;

    if (!fieldDataCopy) return null;
    
    if (fieldDataCopy?.structure) {
        fieldDataCopy.structure.required = true;
    }

    let props = {
        defaultValue: fieldDataCopy?.defaultValue ?? '', // default value
        name: fieldDataCopy?.id,
        data: fieldDataCopy,
        setIsEdited: setIsEdited,
        onChangeEdit: onChangeEdit,
        setOnChangeEdit: setOnChangeEdit,
        errorlist: errorlist,
        setErrorlist: setErrorlist,
        setValue,
        detailTicket: detailTicket,
        viewFromProjectOfEscalateTicket: false,
        label: fieldDataCopy?.name?.jp?.text,
        register: register,
        listFieldEdited: listFieldEdited,
        setListFieldEdited: setListFieldEdited,
        triggerEnableBtnSaveTicket,
    }

    return <RichTextEditor {...props} />;
    
}
